import { PortalEligibilityData } from './PortalEligibilityData';
import { PortalIdentifier, PortalSource } from './PortalDataEnums';

export interface SSOPortalEligibilityData extends PortalEligibilityData {
  portalSource?: PortalSource;
  portalIdentifier?: PortalIdentifier;
  isFakeUser?: boolean;
}

export const EmptySSOPortalEligibilityData: SSOPortalEligibilityData = {
  firstName: '',
  lastName: '',
  dob: '',
  memberId: '',
  policyId: '',
  delsysCode: '',
  enablePcp: false,
  useObapiPreprod: false,
  zipCode: '',
  uniqueMemberId: '',
  portalSource: PortalSource.UMR,
  portalIdentifier: PortalIdentifier.STANDARD,
  isFakeUser: false,
};
